var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"pop-up"},[_c('h2',{staticClass:"title title-26"},[_vm._v(_vm._s(_vm.$t('formulario.popup.intro')))]),_vm._v(" "),_vm._l((_vm.$t('formulario.popup.textos')),function(el,key){return [_c('h3',{staticClass:"title title-18"},[_vm._v(_vm._s(el.titulo))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(el.texto))])]})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09f7d10c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/popup-condiciones.vue
// module id = null
// module chunks = 